// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import ProductListView from '../views/ProductListView.vue';
import ProductDetailView from '../views/ProductDetailView.vue';

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/product-list/:categoryId',
        name: 'productList',
        component: ProductListView
    },
    {
        path: '/product-detail/:id',
        name: 'productDetail',
        component: ProductDetailView
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;
